const $ = require("jquery");
import run from "../../utilities/run";
import { setElementsFromScope } from "../../utilities/selectorHelpers";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
require("./crimsonOrderReleaseDetails.less");

const targetSelector = ".order-hold-rule-detail";

run(targetSelector, mainEl => {
  const els = {};

  const posLocations = mainEl.data("pos-locations")

  const releaseRuleUrl = mainEl.data("release-rule-url");

  const elsMap = {
    releaseRuleBtn: ".release-rule-btn",
    posLocationDiv: ".pos-location-codes"
  };

  function init() {
    setElements();
    bindElements();
    setValues();
  }

  function setElements() {
    setElementsFromScope(els, elsMap, mainEl);
  }

  function bindElements() {
    els.releaseRuleBtn.on("click", releaseRule);
  }

  function setValues(){
    if(posLocations){
      const posValues = posLocations.toString().split(",")

      const htmlOutput = posValues.map(val => {
        return `<div>${val.trim()}</div>`
      }).join("")

      els.posLocationDiv.html(htmlOutput);
    }
  }

  function releaseRule(e) {
    e.preventDefault();
    releaseRuleModalFlow.showConfirmModal();
  }

  let releaseRuleModalFlow = new SubmitModalFlow({
    confirmModalTitle: "Release Rule(s)",
    modalDialogClass: "q-modal-dialog-500",
    confirmModalBody: `<div class="q-marg-all-xl">
                             <div class="q-marg-vert-md">
                               Confirming the manual release of this rule(s) will trigger it's original release schedule, if applicable, to reset and to be released at the current time.
                             </div>
                             <div class="q-marg-vert-md">
                               Once released, all orders impacted by this rule(s) will begin to be processed. 
                             </div>
                           </div>`,
    confirmModalBtnText: "Release",
    onConfirmClick: function() {
      releaseRuleModalFlow.showLoadingModal();
      releaseRules();
      function releaseRules() {
        $.ajax({
          url: releaseRuleUrl,
          type: "POST",
          dataType: "JSON",
          success: function(data) {
            if (data.response == "success") {
              releaseRuleModalFlow.showSuccessModal();
              location.reload();
            } else {
              releaseRuleModalFlow.showFailureModal();
            }
          },
          error: function(data) {
            releaseRuleModalFlow.hideAllModals();
          }
        });
      }
    }
  });

  releaseRuleModalFlow.init();

  init();
});



// WEBPACK FOOTER //
// ./src/pages/orderHoldRuleDetails/index.js